import React, { useContext, useEffect, useState } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";
import ModalSave from "../../common/ModelSave";
import { CancelButton, SaveButton } from "../../common/Button";
import { Row, Col, Form, InputGroup, Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import classNames from "classnames";
import { putData } from "../../../utils/api";
import { useLoader } from "../../../utils/common";

const API_URL = "/admin/about-us/our-team";

// new file wins over the stored image
const Preview = ({ file, current, base }) => {
  const [url, setUrl] = useState("");
  useEffect(() => {
    if (file && file.length) {
      const u = URL.createObjectURL(file[0]);
      setUrl(u);
      return () => URL.revokeObjectURL(u);
    }
    setUrl("");
  }, [file]);
  const src = url || (current ? base + current : "");
  if (!src) return null;
  return <img src={src} alt="Preview" className="image-preview mt-2" style={{ maxWidth: 140, maxHeight: 140 }} />;
};

const EditTeam = ({ id, handleClose }) => {
  const { getData, IMG_URL } = useContext(Context);
  const { withLoader } = useLoader();
  const [showModal, setShowModal] = useState({ code: 0, message: "" });
  const [existingImage, setExistingImage] = useState("");

  const {
    register,
    handleSubmit,
    reset,
    watch,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    (async () => {
      const response = await withLoader(() => getData(`${API_URL}/${id}`));
      const d = { ...(response?.data || {}) };
      setExistingImage(d.image || "");
      delete d.image; // the file input only carries a newly picked file
      reset(d);
    })();
    // eslint-disable-next-line
  }, [id]);

  const onSubmit = async (data) => {
    try {
      const sendData = new FormData();
      sendData.append("team_type", data.team_type);
      sendData.append("name", data.name);
      sendData.append("designation", data.designation);
      sendData.append("qualification", data.qualification || "");
      sendData.append("expertise", data.expertise || "");
      sendData.append("description", data.description || "");
      sendData.append("sort_order", data.sort_order || 0);
      // only send an image when a new one was picked; otherwise the stored one stays
      if (data.image && typeof data.image !== "string" && data.image.length) {
        sendData.append("image", data.image[0]);
      }

      const response = await withLoader(() => putData(`${API_URL}/${id}`, sendData));
      setShowModal({ code: response?.code, message: response?.message });
      setTimeout(() => {
        setShowModal({ code: 0, message: "" });
        if (response?.success) handleClose();
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <Modal
        show
        onHide={handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="edit-modal-holder"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">Edit Team Member</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={(e) => e.preventDefault()} role="form">
            <Row className="justify-content-center">
              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <Form.Label>Type</Form.Label>
                    <InputGroup className="d-block">
                      <Form.Control
                        as="select"
                        className={classNames("w-100", { "is-invalid": errors?.team_type })}
                        {...register("team_type", { required: "Type is required" })}
                      >
                        <option value="">Select type</option>
                        <option value="leadership">Our Team (founder, management)</option>
                        <option value="expert">Vision expert</option>
                        <option value="staff">Staff</option>
                      </Form.Control>
                    </InputGroup>
                    {errors.team_type && <span className="text-danger">{errors.team_type.message}</span>}
                  </Form.Group>
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <Form.Label>Display Order</Form.Label>
                    <InputGroup className="d-block">
                      <Form.Control type="number" min={0} className="w-100" {...register("sort_order")} />
                    </InputGroup>
                    <small className="text-muted">Lower numbers show first within the same type.</small>
                  </Form.Group>
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <Form.Label>Name</Form.Label>
                    <InputGroup className="d-block">
                      <Form.Control
                        type="text"
                        placeholder="Name"
                        maxLength={100}
                        className={classNames("w-100", { "is-invalid": errors?.name })}
                        {...register("name", {
                          required: "Name is required",
                          maxLength: { value: 100, message: "Name should not exceed 100 characters" },
                        })}
                      />
                    </InputGroup>
                    {errors.name && <span className="text-danger">{errors.name.message}</span>}
                  </Form.Group>
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <Form.Label>Designation</Form.Label>
                    <InputGroup className="d-block">
                      <Form.Control
                        type="text"
                        placeholder="e.g. Vision expert"
                        maxLength={100}
                        className={classNames("w-100", { "is-invalid": errors?.designation })}
                        {...register("designation", {
                          required: "Designation is required",
                          maxLength: { value: 100, message: "Designation should not exceed 100 characters" },
                        })}
                      />
                    </InputGroup>
                    {errors.designation && <span className="text-danger">{errors.designation.message}</span>}
                  </Form.Group>
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <Form.Label>Qualification (optional)</Form.Label>
                    <InputGroup className="d-block">
                      <Form.Control
                        type="text"
                        maxLength={200}
                        placeholder="B. Optometry, M. Optometry, MBA"
                        className="w-100"
                        {...register("qualification")}
                      />
                    </InputGroup>
                  </Form.Group>
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <Form.Label>Expertise (optional)</Form.Label>
                    <InputGroup className="d-block">
                      <Form.Control
                        type="text"
                        maxLength={300}
                        placeholder="Myopia Control Lens Consultant, Contact Lens Consultant"
                        className="w-100"
                        {...register("expertise")}
                      />
                    </InputGroup>
                  </Form.Group>
                </div>
              </Col>

              <Col md={12}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <Form.Label>Description (optional)</Form.Label>
                    <InputGroup className="d-block">
                      <Form.Control
                        as="textarea"
                        rows={4}
                        placeholder="A short note about this person"
                        className="w-100"
                        {...register("description")}
                      />
                    </InputGroup>
                  </Form.Group>
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <Form.Label>Image</Form.Label>
                    <InputGroup className="d-block">
                      <Form.Control type="file" accept="image/*" className="w-100" {...register("image")} />
                    </InputGroup>
                    <small className="text-muted">Leave empty to keep the current image.</small>
                  </Form.Group>
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Label>Image Preview</Form.Label>
                  <div>
                    <Preview file={watch("image")} current={existingImage} base={IMG_URL} />
                  </div>
                </div>
              </Col>

              <Row className="mt-5 pb-3">
                <div className="d-flex justify-content-center">
                  <Link>
                    <CancelButton name={"Cancel"} handleClose={handleClose} />
                  </Link>
                  <SaveButton name={"Save"} handleSubmit={handleSubmit(onSubmit)} />
                </div>
              </Row>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>

      <ModalSave message={showModal.message} showErrorModal={showModal.code ? true : false} />
    </>
  );
};

export default EditTeam;